import * as React from 'react';

export interface FluidColumnsProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Define the number of columns. It is used for the grid in order to define how many features will be displayed in a row. The default value is 3.
   * @default 3
   */
  cols?: number;
  /** Children to render. */
  children: React.ReactNode;
}

export class FluidColumns extends React.PureComponent<FluidColumnsProps> {}
